import type { ICrossTabEvent } from 'bz-utilities/modules/plugins/register/stores/mediator';

export default class ContactRefreshEvent implements ICrossTabEvent {
  public readonly __crossTabEvent = true as const;

  public constructor(init?: Partial<ContactRefreshEvent>) {
    Object.assign(this, init);
  }
}
